module.exports = __webpack_public_path__ + "cachable/fonts/fa-regular-400.9c6f2a1b2322ef037d3d44b2b1a201b4.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/fontawesome-pro/webfonts/fa-regular-400.ttf
// module id = 1184
// module chunks = 0